/**
 * Formata um número ou string numérica para o padrão numérico brasileiro,
 * com duas casas decimais.
 *
 * @param {number | string} valor O valor a ser formatado.
 * @returns {string} O valor formatado (ex: "1.234,56").
 * Retorna "0,00" se a entrada for inválida.
 */
export const formatarNumeroPTBR = (valor) => {
  let numero;

  if (typeof valor === 'string') {
    const valorLimpo = valor.replace(/\./g, '').replace(',', '.');
    numero = parseFloat(valorLimpo);
  } else if (typeof valor === 'number') {
    numero = valor;
  } else {
    return '0,00';
  }

  if (isNaN(numero)) {
    return '0,00';
  }

  // Formata usando o estilo decimal, com no mínimo 2 casas decimais.
  return new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numero);
};

/**
 * Formata um número ou string numérica para o padrão de moeda brasileiro (BRL).
 * A função lida com entradas que possam usar tanto ponto quanto vírgula como separador decimal.
 *
 * @param {number | string} valor O valor a ser formatado.
 * @returns {string} O valor formatado como moeda (ex: "R$ 1.234,56").
 * Retorna "R$ 0,00" se a entrada for inválida.
 */
export const formatarMoedaPTBR = (valor) => {
  let numero;

  // 1. Verifica o tipo de entrada e converte para um número padronizado.
  if (typeof valor === 'string') {
    // Remove pontos de milhar (ex: 1.000) e substitui a vírgula decimal por ponto.
    const valorLimpo = valor.replace(/\./g, '').replace(',', '.');
    numero = parseFloat(valorLimpo);
  } else if (typeof valor === 'number') {
    numero = valor;
  } else {
    // Se o valor for nulo, indefinido ou de outro tipo, retorna um padrão.
    return 'R$ 0,00';
  }

  // 2. Valida se a conversão resultou em um número válido.
  if (isNaN(numero)) {
    return 'R$ 0,00';
  }

  // 3. Usa a API Intl.NumberFormat para a formatação final.
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(numero);
};
